export default "__VITE_ASSET__BO5ASeIB__"